export default "__VITE_ASSET__DErF5yF3__"